import React, { FC, useMemo } from 'react';
import styles from './Campaign2.module.less';
import { Table, Col, Row } from 'antd';
import clsx from 'clsx';
import { TableContainer } from 'components/TableContainer';
import { ColumnsType } from 'antd/lib/table';
import { Surface } from 'components/Surface';
import { useTypeSafeTranslation } from 'hooks';
import { useTop10ORBS } from 'api/auth_token/queries';
import bigDecimal from 'js-big-decimal';
import { formatNumber } from 'utils/number';

const dataSource = [
  { rank: 0, user: '', number: '' },
  { rank: 1, user: '', number: '' },
  { rank: 2, user: '', number: '' },
  { rank: 3, user: '', number: '' },
  { rank: 4, user: '', number: '' },
  { rank: 5, user: '', number: '' },
  { rank: 6, user: '', number: '' },
  { rank: 7, user: '', number: '' },
  { rank: 8, user: '', number: '' },
  { rank: 9, user: '', number: '' },
  { rank: 'Total:', number: '' },
];

const Campaign: FC = () => {
  const { t } = useTypeSafeTranslation();
  const { data } = useTop10ORBS();

  const dataSet = useMemo(() => {
    const total = data?.reduce((pre, nex) => {
      return pre.add(new bigDecimal(nex.number));
    }, new bigDecimal(0));

    return dataSource.map((x) => ({
      ...x,
      user: typeof x.rank === 'number' ? data?.[x.rank]?.nick_name : '',
      number:
        typeof x.rank === 'number'
          ? data?.[x.rank]?.number
          : total?.round(2, bigDecimal.RoundingModes.FLOOR).getPrettyValue(undefined, undefined),
    }));
  }, [data]);

  const columns = useMemo(() => {
    return [
      {
        title: t('campaign.rank'),
        dataIndex: 'rank',
        width: 50,
        render: (value, { rank }, i) => {
          if (rank === 'Total:') {
            return <span className="bold ocean text-16">{t('campaign.total')}</span>;
          }
          return <span className="avenir">{value + 1}</span>;
        },
      },
      {
        title: 'Nickname',
        dataIndex: 'user',
        render: (value, { rank }) => {
          if (rank === 'Total:') {
            return <span className="bold ocean text-16">{value}</span>;
          }
          return <span className="bold avenir">{value}</span>;
        },
      },
      {
        title: 'Stake Amount',
        align: 'right',
        dataIndex: 'number',
        render: (value, { rank }) => {
          if (rank === 'Total:') {
            return <span className="bold ocean text-16">{value}</span>;
          }
          return <span className="normal avenir">{formatNumber(value, 2)}</span>;
        },
      },
    ] as ColumnsType<any>;
  }, [t]);

  return (
    <>
      <div className={clsx(styles.root, 'container')}>
        <p className={styles.tableTitle}>TOP 10 ORBS STAKERS</p>

        <Surface borderMd className={styles.table}>
          <span className="bold">RANKING</span>
          <TableContainer className={styles.tableContainer} filled>
            <Table rowKey="rank" scroll={{ x: true }} columns={columns} dataSource={dataSet} pagination={false} />
          </TableContainer>
        </Surface>
        <p className="center ocean text-12">
          <i>
            *This is an approximate amount. The actual amount may fluctuate where as the updated status will be
            preferenced.
          </i>
        </p>
        <div className={styles.divider} />
        <img className={styles.angleLeftBottom} src="/images/campaign/polygon_blur.png" alt="decor" />
        <img className={styles.angleRightBottom} src="/images/campaign/polygon_md.png" alt="decor" />
      </div>
    </>
  );
};

export default Campaign;
